import { COLOR_STYLES_V2, DEFAULT_STYLES } from '../constants/styles';

export const setTheme = ({ theme }) => {
  const themeStyles = () => {
    if (theme === 'color-style-v2') {
      return COLOR_STYLES_V2;
    } else {
      return DEFAULT_STYLES;
    }
  };
  Object.entries(themeStyles()).forEach(([key, value]) => {
    document.documentElement.style.setProperty(key, value);
  });
};
